import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-model",
  "use": "icon-model-usage",
  "viewBox": "0 0 1920 5155",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1920 5155\" id=\"icon-model\">\r</symbol>"
});
var result = sprite.add(symbol);
export default symbol